const VERSION = '2.0.5p'
export default VERSION
